<template>
  <el-row :key="key" class="container">
    <el-col :span="24">
      <el-card>
        <div class="card-body">
          <div class="card-content">
            <div class="feed-name">
              {{ name }}
            </div>
            <div v-if="invoiceType === 'store'">
              {{
                `Total sum:
              ${$filters.formatNumber(invoicePayment.total / 100)}
              ${invoicePayment.store.currency_iso_code}`
              }}
            </div>
            <div v-for="index in Object.keys(invoiceLinks)" :key="index">
              <button class="btn btn-primary" @click="handleInvoiceDownload(invoiceLinks[index], index)">
                {{ index }}
              </button>
            </div>
          </div>
          <div class="btn-container">
            <!-- prettier-ignore -->
            <el-button
              v-if="invoicePayment.credit_invoice_url && invoiceType === 'store'" class="invoice-link"
              size="large"              
              @click="handleInvoiceDownload(creditInvoiceLink, 'credit')"
            >
              Credit
            </el-button>

            <el-button
              v-if="!invoicePayment.credit_invoice_url && invoicePayment.locked && invoiceType === 'store'"
              size="large"
              :loading="isCreatingCreditInvoice"
              @click="dialog = true"
            >
              Create credit invoice
            </el-button>

            <!-- prettier-ignore -->
            <el-button
v-if="!invoicePayment.locked" size="large" :loading="isRecalculating"
              @click="handleRecalculation(invoicePayment.id)">
              Recalculate
            </el-button>
            <!-- prettier-ignore -->
            <el-button
v-if="!invoicePayment.locked" type="primary" size="large" :loading="isChangingApprovement"
              @click="handleApprovementChange(invoicePayment.id)">
              {{ isAlreadyApproved ? 'UnApprove' : 'Approve' }}
            </el-button>

            <el-dialog v-model="dialog" title="Confirm" width="30%" draggable>
              <span>Are you sure you want create a credit invoice?</span>
              <template #footer>
                <span class="dialog-footer">
                  <el-button @click="dialog = false">Cancel</el-button>
                  <el-button type="primary" @click="confirmCreateCreditInvoice(invoicePayment.id)"> Confirm </el-button>
                </span>
              </template>
            </el-dialog>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import httpClient from '../api/httpClient'

export default {
  props: {
    // eslint-disable-next-line vue/no-reserved-props
    key: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
    },
    invoicePayment: {
      type: Object,
      required: true,
    },
    invoiceType: {
      type: String,
      default: 'store',
    },
    onApprovementChange: {
      type: Function,
      required: true,
    },
    onRecalculation: {
      type: Function,
      required: true,
    },
    onCreateCreditInvoice: {
      type: Function,
    },
    invoiceLinks: {
      type: Object,
      required: true,
    },
    creditInvoiceLink: {
      type: String,
    },
  },
  data() {
    return {
      isAlreadyApproved: false,
      isRecalculating: false,
      isChangingApprovement: false,
      isCreatingCreditInvoice: false,
      dialog: false,
    }
  },
  computed: {
    name() {
      return this.invoiceType === 'store' ? this.invoicePayment.store.feed_name : this.invoicePayment.client_payment_organization.name
    },
  },
  created() {
    this.isAlreadyApproved = this.invoicePayment.accepted_by !== null
  },
  methods: {
    async handleRecalculation(id) {
      try {
        this.isRecalculating = true
        await this.onRecalculation(id)
      } catch (error) {
        console.error(error)
      } finally {
        this.isRecalculating = false
      }
    },
    async handleApprovementChange(id) {
      try {
        this.isChangingApprovement = true
        await this.onApprovementChange({ id, isApproved: !this.isAlreadyApproved })
      } catch (error) {
        console.error(error)
      } finally {
        this.isChangingApprovement = false
      }
    },
    async createCreditInvoice(id) {
      try {
        this.isCreatingCreditInvoice = true
        await this.onCreateCreditInvoice(id)
      } catch (error) {
        console.error(error)
      } finally {
        this.isCreatingCreditInvoice = false
      }
    },
    confirmCreateCreditInvoice(id) {
      this.dialog = false
      this.createCreditInvoice(id)
    },

    async handleInvoiceDownload(invoiceUrl, index) {
      try {
        const url = new URL(invoiceUrl)
        const endpoint = url.pathname + url.search

        const response = await httpClient.post(
          endpoint,
          {},
          {
            responseType: 'blob',
          },
        )

        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', this.getInvoiceFileName(index))
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(downloadUrl)
      } catch (error) {
        console.error(error)
      }
    },

    getInvoiceFileName(index) {
      const today = new Date().toISOString().split('T')[0]
      const extension = index.toLowerCase() === 'excel' ? 'xlsx' : 'pdf'
      return `invoice-${index}-${this.invoicePayment.invoice_date?.slice(0, -3) || today}-${today}.${extension}`
    },
  },
}
</script>

<style scoped>
.container {
  margin: 10px 0;
}

.card-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.card-content {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.feed-name {
  text-transform: capitalize;
}

.invoice-link {
  text-decoration: none;
  text-transform: uppercase;
}

@media (max-width: 412px) {
  .card-content {
    margin-bottom: 20px;
  }
}
</style>
